<template>
  <span>
    <b-button v-b-modal.authorization-modal class="float-right"><i class="fa fa-2x fa-gear"></i></b-button>
    <authorize-modal @onSuccess="show"></authorize-modal>
    <b-modal id="modal-process-options" title="Opciones de proceso">
      <b-form-checkbox v-model="process_options.square_by_lot" name="check-button" switch class="mb-2">
        Cuadrar proceso por lote
      </b-form-checkbox>
      <b-form-checkbox v-model="process_options.sag_filter" name="check-button" switch class="mb-2">
        No mezclar productores, variedades y condicion
      </b-form-checkbox>
    </b-modal>
  </span>
</template>

<script>
import AuthorizeModal from "@/views/reusable/AuthorizeModal";
export default {
  name: "ProcessOptions",
  components: {
    AuthorizeModal
  },
  props: ["process_options"],
  watch: {
    "process_options.square_by_lot"(n_value, o_value) {
      localStorage.setItem("ppo.square_by_lot", n_value);
    },
    "process_options.sag_filter"(n_value, o_value) {
      localStorage.setItem("ppo.sag_filter", n_value);
    }
  },
  methods: {
    show() {
      this.$bvModal.show("modal-process-options");
    }
  }
};
</script>

<style></style>
